import React, {Component} from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import CommonService from "../services/common.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import signalDispatcherInstance from "../utils/signalDispatcher";
import axios from "axios";
import config from "../config.json";
import userEventService from "../services/user-event.service";

let common = new CommonService();

interface PaymentPageState {
    paymentStatus: string;
    transactionId: string;
    orderID: string;
    translations: Record<string, any>;
    r: string;
    errorMessage?: string;
    errorCode?: string;
}


class PaymentPage extends Component<{}, PaymentPageState> {
    constructor(props: any) {
        super(props);
        const searchParams = new URLSearchParams(window.location.search);
        const requestID = searchParams.get('r'); 
        this.state = {
            paymentStatus: '',
            transactionId: '',
            orderID: '',
            translations: JSON.parse(localStorage.getItem('translations') || '[]'),
            r: requestID ? requestID : ''
        };
    }

    componentDidMount(): void {
        userEventService.sendEvent('page_view', 'payment_return', { r: this.state.r });
        let id = '';
        if (this.state.r !== '') {
            const parameters: any = JSON.parse(atob(this.state.r));
            localStorage.setItem('uuid', parameters.o);
            id = parameters && parameters.o ? parameters.o : localStorage.getItem('uuid');
            const errorMessage = parameters && parameters.r ? this.state.translations.filter((item: any) => item.setting_name === parameters.r.toString())[0].setting_value_text : '';
            this.setState({ 
                errorMessage: errorMessage, 
                errorCode: parameters && parameters.r ? parameters.r.toString() : '' 
            });
        }
        else {
            id = localStorage.getItem('uuid') || '';
        }
        const timer = setInterval(() => {
            common.getPaymentStatus(id).then((result: any) => {
                userEventService.sendEvent('action', 'payment_status_received', {
                    status: result?.status,
                    transactionId: result?.simple_transaction_id,
                    orderId: result?.order_id
                });
                if (result && result.status && result.status === 'FINISHED') {
                    this.setState({
                        paymentStatus: result.status,
                        transactionId: result.simple_transaction_id,
                        orderID: result.order_id
                    });
                    const orderDetailsData = {
                        order_id: localStorage.getItem('orderID') || '',
                        order_transaction_id: result.simple_transaction_id,
                        order_auth_code: result.status,
                        order_error_code: '',
                        order_error_message: ''
                    };
                    axios.post(config.API + '/frontendUpdateOrderDetails', orderDetailsData, {headers: {'Content-Type': 'application/json'}}).then(response => {
                        this.resetCart();
                        clearInterval(timer);    
                    }).catch(error => {
                        console.error('Error calling resevation:', error);
                    });
                }
                else if (result && result.status && result.status === 'CANELLED') {
                    this.setState({
                        paymentStatus: result.status,
                        transactionId: result.simple_transaction_id,
                        orderID: result.order_id
                    });
                    const orderDetailsData = {
                        order_id: localStorage.getItem('orderID') || '',
                        order_transaction_id: result.simple_transaction_id,
                        order_auth_code: result.status,
                        order_error_code: this.state.errorCode || '',
                        order_error_message: this.state.errorMessage || ''
                    };
                    axios.post(config.API + '/frontendUpdateOrderDetails', orderDetailsData, {headers: {'Content-Type': 'application/json'}}).then(response => {
                        this.resetCart();
                        clearInterval(timer);
                    }).catch(error => {
                        console.error('Error calling resevation:', error);
                    });
                }
                else if (result && result.status && result.status === 'NOTAUTHORIZED') {
                    this.setState({
                        paymentStatus: result.status,
                        transactionId: result.simple_transaction_id,
                        orderID: result.order_id
                    });
                    const orderDetailsData = {
                        order_id: localStorage.getItem('orderID') || '',
                        order_transaction_id: result.simple_transaction_id,
                        order_auth_code: result.status,
                        order_error_code: this.state.errorCode || '',
                        order_error_message: this.state.errorMessage || ''
                    };
                    axios.post(config.API + '/frontendUpdateOrderDetails', orderDetailsData, {headers: {'Content-Type': 'application/json'}}).then(response => {
                        this.resetCart();
                        clearInterval(timer);
                    }).catch(error => {
                        console.error('Error calling resevation:', error);
                    });
                }
                else {
                    this.setState({
                        paymentStatus: result.status,
                        transactionId: result.simple_transaction_id,
                        orderID: result.order_id
                    });
                    const orderDetailsData = {
                        order_id: localStorage.getItem('orderID') || '',
                        order_transaction_id: result.simple_transaction_id,
                        order_auth_code: result.status,
                        order_error_code: this.state.errorCode || '',
                        order_error_message: this.state.errorMessage || ''
                    };
                    axios.post(config.API + '/frontendUpdateOrderDetails', orderDetailsData, {headers: {'Content-Type': 'application/json'}}).then(response => {
                    }).catch(error => {
                        console.error('Error calling resevation:', error);
                    });
                }
            });
        }, 4000);
    }

    private resetCart() {
        localStorage.removeItem('cart');
        localStorage.removeItem('cartExpiryTime');
        localStorage.removeItem('uuid');
        signalDispatcherInstance.emit('updateCartTicket', null);
        signalDispatcherInstance.emit('resetCart', null);
        signalDispatcherInstance.emit('refreshCartCount', 0);
        return true;
    }

    private goToPrint() {
        window.location.href = '/qrcodes/?id=' + this.state.orderID;
    }

    render() {
        return (
            <>
                <Container className="oc-mainpage">
                    <Row>
                        {this.state.paymentStatus !== 'FINISHED' && this.state.paymentStatus !== 'CANCELLED' && this.state.paymentStatus !== 'NOTAUTHORIZED' && this.state.paymentStatus !== 'TIMEOUT' && 
                        <Col key={'pageContent_pending'} lg={6} md={6} sm={12} xs={12}>
                            <h2>
                                <FontAwesomeIcon icon={faSpinner} spin />&nbsp;{this.state.translations.filter((item: any) => item.setting_name === 'WAIT_PAYMENT')[0].setting_value_text}...
                            </h2>
                            <p style={{ marginTop: '32px' }}>
                                {this.state.translations.filter((item: any) => item.setting_name === 'WAIT_PAYMENT_TEXT1')[0].setting_value_text}
                            </p>
                            <p className="highlight">
                                {this.state.translations.filter((item: any) => item.setting_name === 'WAIT_PAYMENT_TEXT2')[0].setting_value_text}
                            </p>
                        </Col>
                        }
                        {this.state.paymentStatus === 'FINISHED' && 
                        <Col key={'pageContent_completed'} lg={6} md={6} sm={12} xs={12}>
                            <h2>
                                {this.state.translations.filter((item: any) => item.setting_name === 'PAYMENT_OK')[0].setting_value_text}
                            </h2>
                            <p style={{ marginTop: '32px' }}>
                                {this.state.translations.filter((item: any) => item.setting_name === 'PAYMENT_OK2')[0].setting_value_text}<br />
                                {this.state.translations.filter((item: any) => item.setting_name === 'ORDERID')[0].setting_value_text}: <strong>{this.state.orderID}</strong>.<br />
                                {this.state.translations.filter((item: any) => item.setting_name === 'TRXID')[0].setting_value_text}: <strong>{this.state.transactionId}</strong>.
                            </p>
                            <p className="highlight">
                                {this.state.translations.filter((item: any) => item.setting_name === 'PAYMENT_OK3')[0].setting_value_text}
                            </p>
                            <p style={{ marginTop: '32px', float: 'left' }}>
                                <Button variant="primary" className="oc-btn-print" onClick={() => this.goToPrint()}>{this.state.translations.filter((item: any) => item.setting_name === 'GO_TO_PRINT')[0].setting_value_text}</Button>
                            </p>
                        </Col>
                        }
                        {this.state.paymentStatus === 'CANCELLED' && this.resetCart() && 
                        <Col key={'pageContent_cancelled'} lg={6} md={6} sm={12} xs={12}>
                            <h2>
                                {this.state.translations.filter((item: any) => item.setting_name === 'PAYMENT_CANCEL')[0].setting_value_text}
                            </h2>
                            <p style={{ marginTop: '32px' }}>
                                <h4>
                                    {this.state.translations.filter((item: any) => item.setting_name === 'ERROR_CODE_LABEL')[0].setting_value_text}: {this.state.errorCode}<br />
                                    {this.state.errorMessage}
                                </h4>
                                {this.state.translations.filter((item: any) => item.setting_name === 'PAYMENT_CANCEL2')[0].setting_value_text}<br />
                                {this.state.translations.filter((item: any) => item.setting_name === 'ORDERID')[0].setting_value_text}: <strong>{this.state.orderID}</strong>.<br />
                                {this.state.translations.filter((item: any) => item.setting_name === 'TRXID')[0].setting_value_text}: <strong>{this.state.transactionId}</strong>.
                            </p>
                            <p className="highlight">
                                {this.state.translations.filter((item: any) => item.setting_name === 'PAYMENT_CANCEL3')[0].setting_value_text}
                            </p>
                        </Col>
                        }
                        {this.state.paymentStatus === 'TIMEOUT' && this.resetCart() && 
                        <Col key={'pageContent_timeoutPayment'} lg={6} md={6} sm={12} xs={12}>
                            <h2>
                                {this.state.translations.filter((item: any) => item.setting_name === 'PAYMENT_TIMEOUT')[0].setting_value_text}
                            </h2>
                            <p style={{ marginTop: '32px' }}>
                                <h4>
                                    {this.state.translations.filter((item: any) => item.setting_name === 'ERROR_CODE_LABEL')[0].setting_value_text}: {this.state.errorCode}<br />
                                    {this.state.errorMessage}
                                </h4>
                                {this.state.translations.filter((item: any) => item.setting_name === 'PAYMENT_TIMEOUT2')[0].setting_value_text}<br />
                                {this.state.translations.filter((item: any) => item.setting_name === 'ORDERID')[0].setting_value_text}: <strong>{this.state.orderID}</strong>.<br />
                                {this.state.translations.filter((item: any) => item.setting_name === 'TRXID')[0].setting_value_text}: <strong>{this.state.transactionId}</strong>.
                            </p>
                            <p className="highlight">
                                {this.state.translations.filter((item: any) => item.setting_name === 'PAYMENT_TIMEOUT3')[0].setting_value_text}
                            </p>
                        </Col>
                        }
                        {this.state.paymentStatus === 'NOTAUTHORIZED' && this.resetCart() && 
                        <Col key={'pageContent_notauth'} lg={6} md={6} sm={12} xs={12}>
                            <h2>
                                {this.state.translations.filter((item: any) => item.setting_name === 'PAYMENT_UNAUTH')[0].setting_value_text}
                            </h2>
                            <p style={{ marginTop: '32px' }}>
                                <h4>
                                    {this.state.translations.filter((item: any) => item.setting_name === 'ERROR_CODE_LABEL')[0].setting_value_text}: {this.state.errorCode}<br />
                                    {this.state.errorMessage}
                                </h4>
                                {this.state.translations.filter((item: any) => item.setting_name === 'PAYMENT_UNAUTH2')[0].setting_value_text}<br />
                                {this.state.translations.filter((item: any) => item.setting_name === 'ORDERID')[0].setting_value_text}: <strong>{this.state.orderID}</strong>.<br />
                                {this.state.translations.filter((item: any) => item.setting_name === 'TRXID')[0].setting_value_text}: <strong>{this.state.transactionId}</strong>.
                            </p>
                            <p className="highlight">
                                {this.state.translations.filter((item: any) => item.setting_name === 'PAYMENT_UNAUTH3')[0].setting_value_text}
                            </p>
                        </Col>
                        }
                    </Row>
                </Container>
            </>
        );
    }
}

export default PaymentPage;